export default __webpack_public_path__ + "static/media/Logo-sinfin-spread_spreadsuite-retail edition.336aa260.svg";